import { useState, useEffect } from 'react';
import { api, endpoints } from '../config/api';
import { PageTitle } from '../components';
import { useConfig } from '../context/ConfigContext';
import { getAssetUrl } from '../config/assets';

function PromocionesPage() {
  const { config } = useConfig();
  const mujerKvUrl = config?.mujerKvUrl || getAssetUrl('mujerKv');
  const logoMedicina = config?.welcomeLogos?.[0]?.url || getAssetUrl('logoMedicina');
  const logoHeel = config?.welcomeLogos?.[1]?.url || getAssetUrl('logoHeel');
  const [promociones, setPromociones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fullscreenImage, setFullscreenImage] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const ev = await api.get(endpoints.eventActive());
        if (ev?.id) {
          const data = await api.get(endpoints.promotionsByEvent(ev.id));
          setPromociones(Array.isArray(data) ? data : []);
        } else {
          setPromociones([]);
        }
      } catch (err) {
        setError(err?.message || 'Error al cargar promociones');
        setPromociones([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden pb-20">
      <div
        className="absolute inset-0 -z-10"
        style={{
          background: config?.bodyBackgroundImage
            ? `linear-gradient(180deg, rgba(15, 60, 50, 0.85) 0%, rgba(20, 80, 70, 0.75) 50%, rgba(25, 100, 90, 0.7) 100%), url(${config.bodyBackgroundImage}) center/cover`
            : 'linear-gradient(180deg, #0f3c32 0%, #145046 50%, #19645a 100%)',
        }}
      />

      <div className="relative z-0 flex flex-col flex-1 items-center justify-between px-4 pt-6">
        <div className="relative z-0 flex flex-col flex-col items-center justify-between px-4 pt-10">
          <div className="relative w-full overflow-hidden rounded-lg p-3 sm:p-4 flex items-center min-h-[180px] sm:min-h-[250px]">
            {config?.headerImage && (
              <div className="z-10 flex-1 min-w-0 pl-2 sm:pl-4 mr-12 sm:mr-20">
                <img src={config.headerImage} alt="37 Simposio" className="h-auto w-full max-w-[280px] sm:max-w-[326px] object-contain object-left" />
              </div>
            )}
            {mujerKvUrl && (
              <div className="absolute right-0 bottom-0 h-full w-1/3 sm:w-1/4 flex justify-center items-end pointer-events-none">
                <img src={mujerKvUrl} alt="" className="h-[100%] sm:h-[110%] w-auto object-contain object-bottom mix-blend-screen brightness-110 opacity-50 sm:opacity-60" />
              </div>
            )}
          </div>
        </div>

        <PageTitle>Promociones</PageTitle>

        <div className="flex-1 w-full max-w-4xl mx-auto p-4 overflow-y-auto">
          <div className="p-4">
            {loading ? (
              <p className="text-center text-gray-500 py-8">Cargando promociones...</p>
            ) : error ? (
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                <p className="text-amber-800">{error}</p>
              </div>
            ) : promociones.length === 0 ? (
              <p className="text-center text-gray-500 py-8">No hay promociones disponibles.</p>
            ) : (
              <ul className="flex flex-col gap-6">
                {promociones.map((p) => (
                  <li key={p.id} className="w-full max-w-2xl mx-auto">
                    {p.imagen ? (
                      <button
                        type="button"
                        onClick={() => setFullscreenImage(p.imagen)}
                        className="block w-full cursor-pointer rounded-lg overflow-hidden shadow-lg hover:opacity-95 transition-opacity focus:outline-none focus:ring-2 focus:ring-[#CEF630] focus:ring-offset-2 bg-black/20"
                      >
                        <img
                          src={p.imagen}
                          alt={p.titulo || 'Promoción'}
                          className="w-full h-auto max-h-[60vh] object-contain object-center"
                        />
                      </button>
                    ) : null}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {fullscreenImage && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4"
            onClick={() => setFullscreenImage(null)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Escape' && setFullscreenImage(null)}
          >
            <button
              type="button"
              onClick={() => setFullscreenImage(null)}
              className="absolute top-40 right-4 z-10 p-2 rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors"
              aria-label="Cerrar"
            >
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img
              src={fullscreenImage}
              alt="Promoción"
              className="max-w-full max-h-[90vh] w-auto h-auto object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>

      <div className="relative z-20 flex justify-between items-end px-4 py-6 pb-8 gap-4">
        <div className="flex flex-col items-start gap-2 min-w-0 flex-1">
          {logoMedicina && (
            <img src={logoMedicina} alt="Medicina Biorreguladora de Sistemas" className="h-[110%] w-auto sm:h-20 object-contain object-left max-w-[75%]" />
          )}
        </div>
        <div className="flex items-end flex-shrink-0">
          {logoHeel && (
            <img src={logoHeel} alt="Heel" className="h-8 sm:h-10 object-contain" />
          )}
        </div>
      </div>
    </div>
  );
}

export default PromocionesPage;
